import React from 'react';
import {
  GoogleReCaptchaContext,
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3';
import { Layout } from './src/components/layout';

const isTrackingDisabled =
  process.env.GATSBY_DISABLE_TRACKING === 'true' ||
  process.env.GATSBY_FORCE_NOINDEX === 'true' ||
  process.env.BRANCH === 'zeta' ||
  process.env.GATSBY_ENV === 'preview' ||
  process.env.GATSBY_ENV === 'development';

const wrapPageElement = ({ element, props }) => {
  const page = <Layout {...props}>{element}</Layout>;

  if (isTrackingDisabled) {
    return (
      <GoogleReCaptchaContext.Provider
        value={{ executeRecaptcha: async () => null }}
      >
        {page}
      </GoogleReCaptchaContext.Provider>
    );
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6LcpGM8ZAAAAAAxPepnhOdvIe2LfdXaXw0iU-q4X"
      scriptProps={{
        async: true,
        defer: true,
        appendTo: 'body',
      }}
    >
      {page}
    </GoogleReCaptchaProvider>
  );
};

export default wrapPageElement;
